import { getPublicClientBookingOrigin } from './clientBookingBaseUrl';

/** URL publique de la page de réservation du pro (slug prioritaire). */
export function buildProBookingProfileUrl(
  proId: number,
  slug?: string | null
): string {
  const origin = getPublicClientBookingOrigin();
  const cleanSlug = slug?.trim();
  if (cleanSlug) {
    return `${origin}/pro/${cleanSlug}`;
  }
  return `${origin}/profile/${proId}`;
}

/** Segment URL d’un service (slug optionnel, sinon service-{id}). */
export function buildServiceUrlSlug(
  serviceId: number,
  serviceSlug?: string | null
): string {
  const clean = serviceSlug?.trim();
  return clean || `service-${serviceId}`;
}

/**
 * URL publique de la fiche service (`/pro/:slug/service/:serviceSlug`).
 * Retourne null si le slug pro est absent (route service exige le slug).
 */
export function buildPublicServiceUrl(
  proSlug: string | null | undefined,
  serviceId: number,
  serviceSlug?: string | null
): string | null {
  const cleanProSlug = proSlug?.trim();
  if (!cleanProSlug) return null;
  const origin = getPublicClientBookingOrigin();
  const servicePath = buildServiceUrlSlug(serviceId, serviceSlug);
  return `${origin}/pro/${encodeURIComponent(cleanProSlug)}/service/${encodeURIComponent(servicePath)}`;
}

export type SocialBookSource = 'instagram' | 'facebook';

/**
 * URL fiche à coller dans le bouton Réserver Instagram / Facebook (Meta).
 * UTM distincts du partage marketing interne. Jamais de schéma intent://.
 */
export function appendSocialBookUtm(url: string, source: SocialBookSource): string {
  const trimmed = url.trim();
  if (/^intent:/i.test(trimmed)) {
    throw new Error('intent:// forbidden for social book button');
  }
  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    throw new Error('invalid booking url');
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    throw new Error('https booking url required');
  }
  parsed.searchParams.set('utm_source', source);
  parsed.searchParams.set('utm_medium', 'book_button');
  return parsed.toString();
}

/** UTM léger pour le partage depuis l’espace marketing interne. */
export function appendMarketingUtm(url: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('utm_source', 'rintintin');
    parsed.searchParams.set('utm_medium', 'marketing');
    return parsed.toString();
  } catch {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}utm_source=rintintin&utm_medium=marketing`;
  }
}
